'use es6';

import PropTypes from 'prop-types';
import { useCallback, useRef } from 'react';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ToolbarActionsPopover = ({
  open,
  placement,
  onOpenChange,
  actions,
  executeAction,
  Button
}) => {
  const buttonRef = useRef(null);
  const handleOpenChange = useCallback(evt => {
    if (evt.target.value === true) {
      buttonRef.current.focus();
    }
    onOpenChange(evt);
  }, [onOpenChange]);
  return /*#__PURE__*/_jsx(UIDropdown, {
    open: open,
    placement: placement,
    onOpenChange: handleOpenChange,
    closeOnOutsideClick: true,
    buttonRef: buttonRef,
    buttonUse: "link-on-dark",
    Button: Button,
    children: /*#__PURE__*/_jsx(UIList, {
      children: actions.map(({
        callback,
        menuLabel,
        menuTooltip,
        disabled,
        id,
        icon,
        iconClassName
      }) => {
        const onClick = () => executeAction({
          id,
          callback
        });
        const button = /*#__PURE__*/_jsxs(UIButton, {
          onClick: onClick,
          disabled: !!disabled,
          children: [/*#__PURE__*/_jsx(UIIcon, {
            name: icon,
            className: iconClassName
          }), menuLabel]
        }, id);
        if (menuTooltip) {
          return /*#__PURE__*/_jsx(UITooltip, {
            title: menuTooltip,
            placement: "right",
            autoPlacement: "horiz",
            children: button
          }, id);
        }
        return button;
      })
    })
  });
};
ToolbarActionsPopover.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  executeAction: PropTypes.func.isRequired,
  placement: PropTypes.string.isRequired,
  actions: PropTypes.array.isRequired,
  Button: PropTypes.func.isRequired
};
export default ToolbarActionsPopover;